(function () {
    window.addEventListener('load', () => {

        document
            .querySelectorAll('a.lien_externe, a.quick-access__link')
            .forEach(link => {

                // Ouverture en nouvel onglet
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');

                // Ajout d'un title "Nouvelle fenêtre" pour les liens externes
                const prefix = CNAM_FO.nouvelleFenetreVers + ' : ';
                // Title existant ou texte du lien en fallback.
                // si pas de title, on utilise l'url
                let title = link.getAttribute('title');
                if (!title || !title.trim()) {
                    title = link.textContent.trim() || link.href;
                }
                link.setAttribute('title', prefix + title);
            });

    });
})();
